import { action } from 'satcheljs';

export const dismissItem = action('ACTIVITY_FEED_ITEM_DISMISS', (itemId: string) => ({ itemId }));
